import type { Item } from "../components/chackraSelectWithClear/chackraSelectWithClear";

import { env } from "./env";

export const ORDERBY_OPTIONS: Item[] = [
  { label: "ID Ascending", value: "MarketDataId asc" },
  { label: "ID Descending", value: "MarketDataId desc" },
  { label: "Name Ascending", value: "MarketDataName asc" },
  { label: "Name Descending", value: "MarketDataName desc" },
  { label: "Provider Ascending", value: "ProviderName asc" },
  { label: "Provider Descending", value: "ProviderName desc" },
];

export const MARKET_DATA_SELECTION_TUTORIAL_URL = "https://www.youtube.com/embed/s2JP2AmKY3U";
export const NUMBER_OF_FACETS_TO_SHOW = 10;
export const LOCAL_PAGINATION_PAGE_SIZE = 50;
export const API_KEY_DATE_PAYLOAD = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";
export const DATE_FORMAT = "YYYY-MM-DD";
export const DATE_WITH_OFFSET_FORMAT = "YYYY-MM-DD HH:mm:ss Z";
export const DATE_FORMAT_WITH_TIME = "YYYY-MM-DDTHH:mm:ss";
export const DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DATETIME_DISPLAY_FORMAT = "dd-MM-yyyy HH:mm:ss";

export const FORBIDDEN_TAGS = ["OriginalGranularity", "OriginalTimezone", "ProviderName", "Type", "UnitOfMeasure"];

export const facetTagNameMapping: Record<string, string> = {
  VersionedTimeSerie: "Versioned Time Series",
  ActualTimeSerie: "Actual Time Series",
  Auction: "Auction",
  MarketAssessment: "Market Assessment",
};

export const statusList = [
  { label: "ACC", value: "ACC" },
  { label: "REJ", value: "REJ" },
  { label: "INC", value: "INC" },
  { label: "REP", value: "REP" },
  { label: "REV", value: "REV" },
  { label: "SUB", value: "SUB" },
  { label: "COM", value: "COM" },
  { label: "PCOM", value: "PCOM" },
];
export const scopeOptions = [
  { value: "NULL", label: "NULL" },
  { value: "ACC", label: "ACC" },
  { value: "AS", label: "AS" },
  { value: "CA", label: "CA" },
  { value: "GR1", label: "GR1" },
  { value: "GR2", label: "GR2" },
  { value: "GR3", label: "GR3" },
  { value: "GR4", label: "GR4" },
  { value: "RS", label: "RS" },
];

export const offerTypeOptions = [
  { label: "Bid", value: "Bid" },
  { label: "Offer", value: "Off" },
];

export const offerStatusOptions = [
  { label: "ACC", value: "ACC" },
  { label: "REJ", value: "REJ" },
  { label: "INC", value: "INC" },
  { label: "REP", value: "REP" },
  { label: "REV", value: "REV" },
  { label: "SUB", value: "SUB" },
  { label: "COM", value: "COM" },
  { label: "PCOM", value: "PCOM" },
];

export const marketOptions = [
  { value: "MGP", label: "MGP" },
  { value: "MIA1", label: "MIA1" },
  { value: "MIA2", label: "MIA2" },
  { value: "MIA3", label: "MIA3" },
  { value: "MI1", label: "MI1" },
  { value: "MI2", label: "MI2" },
  { value: "MI3", label: "MI3" },
  { value: "MI4", label: "MI4" },
  { value: "MI5", label: "MI5" },
  { value: "MI6", label: "MI6" },
  { value: "MI7", label: "MI7" },
  { value: "MSD", label: "MSD" },
  { value: "MB", label: "MB" },
  { value: "MB2", label: "MB2" },
  { value: "MB3", label: "MB3" },
  { value: "MB4", label: "MB4" },
  { value: "MB5", label: "MB5" },
  { value: "MB6", label: "MB6" },
  { value: "MBh", label: "MBh" },
  { value: "MRR", label: "MRR" },
  { value: "MIXBID", label: "MIXBID" },
  { value: "AFRR", label: "AFRR" },
];

export const baTypeOptions = [
  { value: "NULL", label: "NULL" },
  { value: "NETT", label: "NETT" },
  { value: "NREV", label: "NREV" },
  { value: "REV", label: "REV" },
];

export const zoneOptions = [
  { value: "AUST", label: "AUST" },
  { value: "BRNN", label: "BRNN" },
  { value: "CALA", label: "CALA" },
  { value: "CNOR", label: "CNOR" },
  { value: "COAC", label: "COAC" },
  { value: "CORS", label: "CORS" },
  { value: "CSUD", label: "CSUD" },
  { value: "FOGN", label: "FOGN" },
  { value: "FRAN", label: "FRAN" },
  { value: "GREC", label: "GREC" },
  { value: "MALT", label: "MALT" },
  { value: "NORD", label: "NORD" },
  { value: "PRGP", label: "PRGP" },
  { value: "ROSN", label: "ROSN" },
  { value: "SARD", label: "SARD" },
  { value: "SICI", label: "SICI" },
  { value: "SLOV", label: "SLOV" },
  { value: "SUD", label: "SUD" },
  { value: "SVIZ", label: "SVIZ" },
];

export const unitTypeOptions = [
  { value: "UP", label: "UP" },
  { value: "UPV", label: "UPV" },
  { value: "UC", label: "UC" },
  { value: "UCV", label: "UCV" },
];

export const generationTypeOptions = [
  { value: "UNKNOWN", label: "UNKNOWN" },
  { value: "OTHER", label: "OTHER" },
  { value: "AUTOGENERATION", label: "AUTOGENERATION" },
  { value: "BIOMASS", label: "BIOMASS" },
  { value: "COAL", label: "COAL" },
  { value: "WIND", label: "WIND" },
  { value: "PV", label: "PV" },
  { value: "GAS", label: "GAS" },
  { value: "GASOIL", label: "GASOIL" },
  { value: "THERMAL", label: "THERMAL" },
  { value: "HYDRO", label: "HYDRO" },
  { value: "MIXED", label: "MIXED" },
  { value: "OIL", label: "OIL" },
];

export const granularityOptions = [
  { value: "Minute", label: "Minute" },
  { value: "TenMinute", label: "TenMinute" },
  { value: "FifteenMinute", label: "FifteenMinute" },
  { value: "ThirtyMinute", label: "ThirtyMinute" },
  { value: "Hour", label: "Hour" },
  { value: "Day", label: "Day" },
  { value: "Week", label: "Week" },
  { value: "Month", label: "Month" },
  { value: "Quarter", label: "Quarter" },
  { value: "Year", label: "Year" },
  { value: "Season", label: "Season" },
];
export const timeZonesOptions = [
  { value: "CET", label: "CET" },
  { value: "WET", label: "WET" },
  { value: "EET", label: "EET" },
  { value: "UTC", label: "UTC" },
  { value: "Europe/Istanbul", label: "Europe/Istanbul" },
  { value: "Europe/Moscow", label: "Europe/Moscow" },
];

export const excelNames: { name: string; excel: string; templateName: string; type: string | null }[] = [
  {
    name: "ActualTSExtraction",
    excel: "ActualTSExtraction",
    templateName: "GenericExtraction",
    type: null,
  },
  {
    name: "ActualTSExtraction Pivoted CurveName",
    excel: "ActualTSExtraction_Pivoted_CurveName",
    templateName: "GenericExtraction",
    type: "CurveName",
  },
  {
    name: "ActualTSExtraction Pivoted Time",
    excel: "ActualTSExtraction_Pivoted_Time",
    templateName: "GenericExtraction",
    type: "Time",
  },
];

export const alternateExcelNames: { name: string; excel: string; templateName: string; type: string | null }[] = [
  {
    name: "MAS",
    excel: "MAS",
    templateName: "GenericExtraction",
    type: null,
  },
  {
    name: "BidAsk",
    excel: "BidAsk",
    templateName: "GenericExtraction",
    type: null,
  },
  {
    name: "Auction",
    excel: "Auction",
    templateName: "GenericExtraction",
    type: null,
  },
];

export const versionedExcelNames: { name: string; excel: string; templateName: string; type: string | null }[] = [
  {
    name: "VersionedTSExtraction",
    excel: "VersionedTSExtraction",
    templateName: "GenericExtraction",
    type: null,
  },
  {
    name: "VersionedTSExtraction Pivoted CurveName",
    excel: "VersionedTSExtraction_Pivoted_CurveName",
    templateName: "GenericExtraction",
    type: "CurveName",
  },
  {
    name: "VersionedTSExtraction Pivoted Time",
    excel: "VersionedTSExtraction_Pivoted_Time",
    templateName: "GenericExtraction",
    type: "Time",
  },
  {
    name: "VersionedTSExtraction Pivoted Version",
    excel: "VersionedTSExtraction_Pivoted_Version",
    templateName: "GenericExtraction",
    type: "Version",
  },
];

export enum AclPath {
  Expectation = "expectation",
  TimeTransform = "timetransform",
  Filter = "filter",
  ApiKey = "apikey",
  GmePublicOffer = "gmepublicoffer",
  PrincipalGroup = "principal/group",
}
export const meteringPowerAndGasAclPath = `marketdata/system/${env.meteringProvider}`;

export enum UserPermissionLevel {
  Read = "readOnly",
  Write = "write",
}

export enum Role {
  Reader = "Reader",
  Contributer = "Contributer",
  Editor = "Editor",
  Owner = "Owner",
  Creator = "Creator",
  SecurityManager = "SecurityManager",
}
